import { render, staticRenderFns } from "./AdministrationTaskQueue.vue?vue&type=template&id=0a90dd0f&scoped=true&"
import script from "./AdministrationTaskQueue.vue?vue&type=script&lang=js&"
export * from "./AdministrationTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationTaskQueue.vue?vue&type=style&index=0&id=0a90dd0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a90dd0f",
  null
  
)

export default component.exports